const onlineUsersStyles = (theme) => ({
    userList: {
        flexGrow: 1,
        padding: theme.spacing(3)
    }
})

export default onlineUsersStyles